export default __webpack_public_path__ + "static/ciUkbQft-48296b08d062887ca8517f71d82c88be.svg";